import * as React from "react";
import Box from "@mui/material/Box";
import WindPlot from "../wind";
import WeatherPlot from "../weather";
import PressurePlot from "../pressure";
import { a11yProps, CustomTabPanel, getStationData } from "../util";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Load weather and lake temperature forecasts
// let [vmax_isl, speed_isl, dir_isl, t2m_isl, precip_isl, dursun_isl, twater_isl] = await loadData("ISL");
// let [vmax_gro, speed_gro, dir_gro, t2m_gro, precip_gro, dursun_gro, twater_gro] = await loadData("GRO");
// let qff = await loadQFF("KLO_LUG");

export default function Urnersee ({ forecast }) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let [vmax_isl, speed_isl, dir_isl, t2m_isl, precip_isl, dursun_isl, twater_isl, qff_isl] = getStationData(forecast, "ISL", "lucerneurnersee", "QFF_KLO_LUG");
  let [vmax_gro, speed_gro, dir_gro, t2m_gro, precip_gro, dursun_gro, twater_gro, qff_gro] = getStationData(forecast, "GRO", "lucerneurnersee", "QFF_KLO_LUG");

  return (
    <div>
      <title>Urnersee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Urnersee</h2>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange} aria-label="tabs" variant="fullWidth">
                <Tab label="Gruonbach" {...a11yProps(0)} />
                <Tab label="Isleten" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_gro} speed={speed_gro} dir={dir_gro} />
                <PressurePlot qff={qff_gro} label="Zürich − Lugano" label_plus="Nordwind" label_minus="Föhn" />
                <WeatherPlot t2m={t2m_gro} precip={precip_gro} sun={dursun_gro} twater={twater_gro} />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_isl} speed={speed_isl} dir={dir_isl} />
                <PressurePlot qff={qff_isl} label="Zürich − Lugano" label_plus="Nordwind" label_minus="Föhn" />
                <WeatherPlot t2m={t2m_isl} precip={precip_isl} sun={dursun_isl} twater={twater_isl} />
              </Box>
            </CustomTabPanel>
          </Box>
          <a href="https://www.limmattalerwetter.ch/forecast/lake_lucerne.webp">
            <img
              className="windplot"
              src="https://www.limmattalerwetter.ch/forecast/lake_lucerne.webp"
              alt="Map of probability of wind exceeding threshold"
            />
          </a>
        </div>
      </div>
    </div>
  );
};
